import { MedicineBoxOutlined, PhoneOutlined, FieldNumberOutlined } from '@ant-design/icons';
import { Col, Row, Button } from 'antd';
import { billingSelectors } from 'containers/App/selectors';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { useSelector } from 'react-redux';
import Wrap from './styles';

type Props = {
  onSearch: (value: any) => void;
};

type InitialValues = {
  facility_name: string;
  address: string;
  phone: string;
};

const SearchBilling = ({ onSearch }: Props) => {
  const { searchValue } = useSelector(billingSelectors);
  const handleSubmit = (value: InitialValues, form: any) => {
    form.setSubmitting(false);
    onSearch(value);
  };

  const handleReset = () => {
    onSearch(undefined);
  };
  return (
    <Wrap>
      <Formik
        onSubmit={handleSubmit}
        onReset={handleReset}
        initialValues={searchValue}
        render={() => (
          <Form>
            <Row className="detail">
              <Col span={15}>
                <Row>
                  <Col span={12} className="search">
                    <MedicineBoxOutlined className="icon1" />
                    <p className="standardBoldFont">医療機関</p>
                    <Form.Item name="search">
                      <Input className="input-search" name="facility_name" />
                    </Form.Item>
                  </Col>
                  <Col span={3} className="search">
                    <PhoneOutlined className="icon1" />
                    <p className="standardBoldFont">TEL</p>
                    <Form.Item name="search">
                      <Input className="input-search" name="phone" />
                    </Form.Item>
                  </Col>
                  <Col span={17} className="search">
                    <FieldNumberOutlined className="icon1" />
                    <p className="standardBoldFont">取引先番号</p>
                    <Form.Item name="search-stk">
                      <Input className="input-search-stk" name="code" />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={7} offset={2} className="btn">
                <Button htmlType="reset" className="Standard backSetup">
                  リセット
                </Button>
                <SubmitButton className="btnSearch Standard btnDefault">絞り込み表示</SubmitButton>
              </Col>
            </Row>
          </Form>
        )}
      />
    </Wrap>
  );
};

export default SearchBilling;
